import React from "react"
import { Image, Send } from "react-feather"

export default (props) => (
  <a href={props.url} className="ambassador card card--pd-sm">
    <div
      className={`ambassador__img-container ${
        props.img ? "" : "ambassador__img-container--placeholder"
      }`}
    >
      {!props.img && <Image />}
      {props.img && (
        <img
          className="lazyload ambassador__img"
          data-src={props.img}
          alt={`${props.firstName} ${props.lastName}`}
          title={`${props.firstName} ${props.lastName}`}
        />
      )}
    </div>
    <div className="ambassador__details">
      <p className="ambassador__name">
        {props.firstName} {props.lastName}
      </p>
      <p className="ambassador__program-location">
        {props.program}, {props.campus}
      </p>
      <p>{props.interests}</p>
    </div>
    <p className="ambassador__cta">
      Get in touch with {props.firstName}
      <Send className="ambassador__cta-i" />
    </p>
  </a>
)
